module.exports = {"621226100":"城关镇","621226101":"盐官镇","621226102":"石桥镇","621226103":"白河镇","621226104":"宽川镇","621226105":"永兴镇","621226106":"祁山镇","621226107":"红河镇","621226108":"永坪镇","621226109":"中坝镇","621226110":"罗坝镇","621226111":"雷坝镇","621226112":"崖城镇","621226113":"洮坪镇","621226114":"龙林镇","621226115":"固城镇","621226116":"江口镇","621226117":"湫山镇","621226118":"白关镇","621226119":"桥头镇","621226120":"王坝镇","621226121":"滩坪镇","621226203":"马河乡","621226215":"上坪乡","621226219":"雷王乡","621226224":"沙金乡","621226228":"草坪乡","621226231":"肖良乡","621226232":"三峪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621226.json
// module id = 2960
// module chunks = 0